import { z } from "zod";

export const selfCertPayloadSchema = z.string();

export type SelfCertPayloadType = z.infer<typeof selfCertPayloadSchema>;
